import React, { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { NumberInformationForm } from "./number-information-form";
import {
  getMultiNetworkSelectionData,
  saveMultiNetworkSelectionData,
} from "utils/purchase-flow-storage";

import { Button } from "app/components/ui/button";

type PersonalInfo = {
  firstName: string;
  lastName: string;
  address: string;
  apt: string;
  city: string;
  zipCode: string;
  state: string;
};

type TransferInfo = {
  accountNumber: string;
  transferPin: string;
  numberToTransfer: string;
};

type FormValues = {
  transferInfo: PersonalInfo & TransferInfo;
  newNumberInfo: PersonalInfo;
};

export const NumberInformation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const savedData = getMultiNetworkSelectionData();
  const form = useForm<FormValues>({
    defaultValues: {
      transferInfo: savedData?.numberInformation?.transferInfo || {
        firstName: "",
        lastName: "",
        address: "",
        apt: "",
        city: "",
        zipCode: "",
        state: "",
        accountNumber: "",
        transferPin: "",
        numberToTransfer: "",
      },
      newNumberInfo: savedData?.numberInformation?.newNumberInfo || {
        firstName: "",
        lastName: "",
        address: "",
        apt: "",
        city: "",
        zipCode: "",
        state: "",
      },
    },
    mode: "onChange",
  });

  const { control, handleSubmit, watch } = form;

  // Save to sessionStorage when form values change
  useEffect(() => {
    const subscription = watch((value) => {
      saveMultiNetworkSelectionData({
        numberInformation: {
          transferInfo: value.transferInfo,
          newNumberInfo: value.newNumberInfo,
        },
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data: FormValues) => {
    console.log("Transfer Info:", data.transferInfo);
    console.log("New Number Info:", data.newNumberInfo);
    navigate("/checkout", {
      state: location.state,
    });
  };

  return (
    <React.Fragment>
      <FormProvider {...form}>
        <form
          className="w-full max-w-[31rem] md:mx-auto space-y-4 sm:space-y-5 lg:space-y-6"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="space-y-4 sm:space-y-5 lg:space-y-6">
            <NumberInformationForm name="transferInfo" />
            <NumberInformationForm name="newNumberInfo" />
          </div>
          <Button type="submit" variant="primary">
            Continue
          </Button>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
